import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import MarketplacePage from "@/pages/MarketplacePage";
import AdvisoryPage from "@/pages/AdvisoryPage";
import GreenProgramPage from "@/pages/GreenProgramPage";
import InitiativesPage from "@/pages/InitiativesPage";
import InsightsPage from "@/pages/InsightsPage";
import ArticleDetailPage from "@/pages/ArticleDetailPage";
import ContactPage from "@/pages/ContactPage";
import WorkWithUsPage from "@/pages/WorkWithUsPage";
import FranchisePage from "@/pages/FranchisePage";
import BharatInitiativePage from "@/pages/BharatInitiativePage";
import CertificatePage from "@/pages/CertificatePage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import EmissionCalculatorPage from "@/pages/EmissionCalculatorPage";
import EnvironmentalCompliancePage from "@/pages/EnvironmentalCompliancePage";
import CarbonCCTSPage from "@/pages/CarbonCCTSPage";
import ClimateProjectsPage from "@/pages/ClimateProjectsPage";
import WasteInfrastructurePage from "@/pages/WasteInfrastructurePage";
import ProductPage from "@/pages/ProductPage";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/advisory" element={<AdvisoryPage />} />
            <Route path="/initiatives" element={<InitiativesPage />} />
            <Route path="/initiatives/bharat-climate" element={<BharatInitiativePage />} />
            <Route path="/programs/:slug" element={<GreenProgramPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/:articleId" element={<ArticleDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/work-with-us" element={<WorkWithUsPage />} />
            <Route path="/franchise" element={<FranchisePage />} />
            <Route path="/certificate/:id" element={<CertificatePage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/emission-calculator" element={<EmissionCalculatorPage />} />
            <Route path="/environmental-compliance" element={<EnvironmentalCompliancePage />} />
            <Route path="/carbon-ccts" element={<CarbonCCTSPage />} />
            <Route path="/climate-projects" element={<ClimateProjectsPage />} />
            <Route path="/waste-infrastructure" element={<WasteInfrastructurePage />} />
            <Route path="/products" element={<ProductPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
